import axios from 'axios'
import config from '../config'

export default {
    getSpeedChartData(data) {
        return axios.post(
            config.publicPath + 'dashboard/speed',
            data,
            {
                headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                },
                validateStatus: function (status) {
                    return status >= 200 && status <= 500;
                },
        });
    },
    getTableData(data) {
        return axios.post(
            config.publicPath + 'dashboard/pmta-relays-count',
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                validateStatus: function (status) {
                    return status >= 200 && status <= 500;
                },
            });
    },
    getServerDateTime() {
        return axios.get(config.publicPath + 'dashboard/date-time',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
    }
}
